import { toast } from 'react-toastify';
import axios from './API';
import { APIENDPOINTS } from './ApiEndPoints/ApiEndpoints';

export const FetchUserData = async (
  page = 1,
  limit = 10,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = { doSort: false }
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS.DASHBOARD.usersURL +
        `?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS.DASHBOARD.usersURL +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}`;
    } else if (search.doSearch) {
      url = APIENDPOINTS.DASHBOARD.usersURL + `?page=${page}&limit=${limit}&search=${search.value}`;
    } else {
      url = APIENDPOINTS.DASHBOARD.usersURL + `?page=${page}&limit=${limit}`;
    }
    const response = await axios.get(url);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const AuthDetails = async () => {
  try {
    const response = await axios.get(APIENDPOINTS.LOGIN.auth);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const sendOtp = async (token, otpId, payload) => {
  try {
    const response = await axios.post(APIENDPOINTS.LOGIN.sendOtp + '/' + otpId, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const resendOtp = async (token, otpId, payload = {}) => {
  try {
    const response = await axios.post(APIENDPOINTS.LOGIN.resendOtp + '/' + otpId, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const verifyOtp = async (token, otpId, payload = {}) => {
  try {
    const response = await axios.post(APIENDPOINTS.LOGIN.verifyOtp + '/' + otpId, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const FetchUserDetails = async id => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.usersRole + `/${id}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const CreateUser = async userData => {
  try {
    const response = await axios.post(APIENDPOINTS.users, userData);
    if (response) return response;
  } catch (error) {
    return error?.response;
    // console.log(error);
  }
};
export const AddUserData = async userData => {
  try {
    const response = await axios.post(APIENDPOINTS?.DASHBOARD?.usersURL, userData);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};
export const EditUserData = async (userId, userData) => {
  try {
    const response = await axios.put(APIENDPOINTS?.DASHBOARD?.usersURL + `/${userId}`, userData);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DeleteUserData = async userId => {
  try {
    const response = await axios.delete(APIENDPOINTS?.DASHBOARD?.usersURL + `/${userId}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const FetchBranchData = async (
  page = 1,
  limit = 10,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = { doSort: false }
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS.DASHBOARD.branchDetails +
        `?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS.DASHBOARD.branchDetails +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}`;
    } else if (search.doSearch) {
      url = APIENDPOINTS.DASHBOARD.branchDetails + `?page=${page}&limit=${limit}&search=${search.value}`;
    } else {
      url = APIENDPOINTS.DASHBOARD.branchDetails + `?page=${page}&limit=${limit}`;
    }

    const response = await axios.get(url);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DownloadBranchData = async type => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.downloadBranch + `?type=${type}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DownloadEnquiryData = async type => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.downloadEnquiry + `?type=${type}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DownloadCustomerData = async type => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.downloadCustomer + `?type=${type}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DownloadApprovalData = async (type, filters = {}) => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.downloadApproval, {
      params: {
        type: type,
        ...filters
      }
    });
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DeshboardReportDownload = async (state, type, quickDateFrom, quickDateTo) => {
  try {
    // let baseURL=   axios.defaults.baseURL;
    // axios.defaults.baseURL= 'http://localhost:5004/api/';
    // axios.defaults.mode= 'no-cors';
    let url = APIENDPOINTS.DASHBOARD.downloadReportDocumennts + `/${state}?type=${type}`;

    if (quickDateFrom) {
      url += `&quickDateFrom=${quickDateFrom}`;
    }

    if (quickDateTo) {
      url += `&quickDateTo=${quickDateTo}`;
    }

    const response = await axios.get(url);
    // axios.defaults.baseURL=baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    // axios.defaults.baseURL=baseURL;
    return error?.response;
  }
};

export const downloadApprovalRequestdData = async (type, quickDateFrom, quickDateTo) => {
  try {
    // let baseURL=   axios.defaults.baseURL;
    // axios.defaults.baseURL= 'http://localhost:5004/api/';
    // axios.defaults.mode= 'no-cors';
    let url = APIENDPOINTS.DASHBOARD.approvalDownload + `?type=${type}`;

    if (quickDateFrom) {
      url += `&quickDateFrom=${quickDateFrom}`;
    }

    if (quickDateTo) {
      url += `&quickDateTo=${quickDateTo}`;
    }

    const response = await axios.get(url);
    // axios.defaults.baseURL=baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    // axios.defaults.baseURL=baseURL;
    return error?.response;
  }
};
export const downloadBulkEsign = async (type, quickDateFrom, quickDateTo) => {
  try {
    // let baseURL=   axios.defaults.baseURL;
    // axios.defaults.baseURL= 'http://localhost:5004/api/';
    // axios.defaults.mode= 'no-cors';
    let url = APIENDPOINTS.DASHBOARD.bulkEsignDownload + `?type=${type}`;

    if (quickDateFrom) {
      url += `&quickDateFrom=${quickDateFrom}`;
    }

    if (quickDateTo) {
      url += `&quickDateTo=${quickDateTo}`;
    }

    const response = await axios.get(url);
    // axios.defaults.baseURL=baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    // axios.defaults.baseURL=baseURL;
    return error?.response;
  }
};

export const DeshboardDownload = async (state, type, quickDateFrom, quickDateTo) => {
  try {
    // let baseURL=   axios.defaults.baseURL;
    // axios.defaults.baseURL= 'http://localhost:5000/api/';
    // axios.mode= 'no-cors';
    let url = APIENDPOINTS.DASHBOARD.downloadDocumennts + `/${state}?type=${type}`;

    if (quickDateTo) {
      url += `&quickDateTo=${quickDateTo}`;
    }

    if (quickDateFrom) {
      url += `&quickDateFrom=${quickDateFrom}`;
    }

    const response = await axios.get(url);
    // axios.defaults.baseURL=baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    // axios.defaults.baseURL=baseURL;
    return error?.response;
  }
};
export const DownloadUserData = async type => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.downloadUser + `?type=${type}`);
    if (response) {
      return response;
    }
    // axios.defaults.baseURL=baseURL;
  } catch (error) {
    // axios.defaults.baseURL=baseURL;
    return error?.response;
  }
};

export const DownloadOrgData = async type => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.downloadOrg + `?type=${type}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DownloadPartnerData = async type => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.downloadPartner + `?type=${type}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const GetUamCount = async () => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.uamCount);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const GetBranchDataById = async id => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.branchDetails + `/${id}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const AddBranchData = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS.DASHBOARD.branchDetails, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const EditBranchData = async (userId, userData) => {
  try {
    const response = await axios.put(APIENDPOINTS?.DASHBOARD?.branchDetails + `/${userId}`, userData);

    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DeleteBranchData = async userId => {
  try {
    const response = await axios.delete(APIENDPOINTS?.DASHBOARD?.branchDetails + `/${userId}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DeleteOrgData = async (orgType, orgId) => {
  try {
    const response = await axios.delete(APIENDPOINTS?.DASHBOARD?.organization + `/${orgType}/${orgId}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const FetchPinccode = async () => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.fetchPincode);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const UserLogin = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS.LOGIN.login, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const userLogout = async () => {
	try {
		const response = await axios.post(APIENDPOINTS.LOGIN.logout);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const FetchLogin = async (token, domain = 'dev.esign-proteantech.in') => {
  try {
    let paramStr = token ? `?domain=${domain}&token=${token}` : `?domain=${domain}`;
    const response = await axios.get(APIENDPOINTS.LOGIN.login + paramStr);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const EnquiryData = async enquiryData => {
  try {
    const response = await axios.post(APIENDPOINTS?.DASHBOARD?.enquiry, enquiryData);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};
export const ForgetPasswordData = async forgotPasswordData => {
  try {
    const response = await axios.post(APIENDPOINTS?.DASHBOARD?.forgotPassword, forgotPasswordData);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const ValidateToken = async token => {
  try {
    const response = await axios.get(APIENDPOINTS.LOGIN.validateToken + `?token=${token}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const ChangePassword = async payload => {
  try {
    const response = await axios.put(APIENDPOINTS?.LOGIN?.resetPassword, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const AddDepartment = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.SETTING?.modifyDepartment, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetDepartment = async (
  page = 1,
  limit = 100,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = { doSort: false }
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS?.SETTING?.modifyDepartment +
        `?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS?.SETTING?.modifyDepartment +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}`;
    } else if (search.doSearch) {
      url = APIENDPOINTS.SETTING.modifyDepartment + `?page=${page}&limit=${limit}&search=${search.value}`;
    } else {
      url = APIENDPOINTS?.SETTING?.modifyDepartment + `?page=${page}&limit=${limit}`;
    }
    // let baseURL=   axios.defaults.baseURL;
    // axios.defaults.baseURL= 'http://localhost:5001/api/';
    const response = await axios.get(url);
    // axios.defaults.baseURL = baseURL;
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateDepartment = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.modifyDepartment + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DeleteDepartment = async id => {
  try {
    const response = await axios.delete(APIENDPOINTS?.SETTING?.modifyDepartment + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const AddRoles = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.SETTING?.roles, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetRoles = async (
  page = 1,
  limit = 100,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = { doSort: false }
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS?.SETTING?.roles +
        `?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS?.SETTING?.roles +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}`;
    } else if (search.doSearch) {
      url = APIENDPOINTS.SETTING.roles + `?page=${page}&limit=${limit}&search=${search.value}`;
    } else {
      url = APIENDPOINTS?.SETTING?.roles + `?page=${page}&limit=${limit}`;
    }

    const response = await axios.get(url);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateRoles = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.roles + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DeleteRoles = async id => {
  try {
    const response = await axios.delete(APIENDPOINTS?.SETTING?.roles + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetPermissions = async id => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.allPermissions + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetAllPermissions = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.allPermissions);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdatePermissions = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.allPermissions + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetGrouping = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.grouping);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateGrouping = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.grouping + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetBrand = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.brand);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateBrand = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.brand + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetWebhook = async type => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.webhook + `?isFillable=${type}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateWebhook = async payload => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.webhook, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const PaymentGatewayAdd = async payload => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.pgConfiguration, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetPaymentGateway = async payload => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.pgConfiguration + `?isFillable=${payload}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};
// -----------------------------------------------------------------------
//  Template Engine API

export const fetchTemplates = async (page, limit, search, template_status = '') => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL= 'http://localhost:5000/api/';

    const response = await axios.get(APIENDPOINTS.TEMPLATE_ENGINE.template, {
      params: { page, limit, search: search || '', template_status: template_status }
    });
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const checkTemplateNameAvailability = async templateName => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL= 'http://localhost:5000/api/';
    const response = await axios.get(`${APIENDPOINTS.TEMPLATE_ENGINE.template_name_availability}/${templateName}`);
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const fetchTemplateById = async templateId => {
  try {
    if (templateId) {
      const response = await axios.get(APIENDPOINTS.TEMPLATE_ENGINE.template + `/${templateId}`);
      if (response) {
        return response;
      }
    }
  } catch (error) {
    return error?.response;
  }
};

export const deleteTemplateById = async templateId => {
  try {
    if (templateId) {
      let baseURL = axios.defaults.baseURL;
      // axios.defaults.baseURL= 'http://localhost:5000/api/';
      const response = await axios.delete(APIENDPOINTS.TEMPLATE_ENGINE.template + `/${templateId}`);
      axios.defaults.baseURL = baseURL;
      if (response) {
        return response;
      }
    }
  } catch (error) {
    return error?.response;
  }
};

export const createTemplate = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS.TEMPLATE_ENGINE.template, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const updateTemplate = async (fileId, payload) => {
  try {
    let baseURL = axios.defaults.baseURL;
    //  axios.defaults.baseURL= 'http://localhost:5000/api/';
    const response = await axios.put(APIENDPOINTS.TEMPLATE_ENGINE.template + `/${fileId}`, payload);
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const addCkAttachmentApi = async (fileId, payload) => {
  try {
    const response = await axios.post(APIENDPOINTS.TEMPLATE_ENGINE.template + `/${fileId}/attachment`, payload);

    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const deleteCkAttachedFile = async (fileId, attachmentId) => {
  try {
    const response = await axios.delete(
      APIENDPOINTS.TEMPLATE_ENGINE.template + `/${fileId}/attachment/${attachmentId}`
    );

    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const removeAttachmentEsignAPI = async (documentId, attachmentId) => {
  try {
    const response = await axios.delete(
      APIENDPOINTS.EDITOR.esign + `/step2/editor/${documentId}/attachment/${attachmentId}`
    );

    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const addDocumentSign = async (documentId, payload) => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL= 'http://localhost:5002/api/';
    delete payload.documentPdf;
    const response = await axios.put(APIENDPOINTS.EDITOR.esign + `/step2/editor/${documentId}`, payload);
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const addCKattachmentEsignAPI = async (documentId, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS.EDITOR.esign + `/step2/editor/${documentId}/attachment`, payload);

    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
//  --------------------------------------------------------------------

export const AddRecipient = async (id, payload) => {
  try {
    if (!payload.isAdditionalAmountRequired) {
      delete payload.additionalAmount;
      delete payload.additionalAmountDescription;
      delete payload.additionalAmountPayeeEmail;
    }

    const response = await axios.put(APIENDPOINTS.NEW_ESIGN.addRecipient + `/${id}`, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const RegistrationData = async (type, payload) => {
  try {
    const response = await axios.post(APIENDPOINTS.REGISTRATION.registration + `/${type}`, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const RegistrationEditData = async (type, id = null, payload) => {
  try {
    let url = APIENDPOINTS.REGISTRATION.registration + `/${type}`;
    let response = null;
    if (id) {
      url += `/${id}`;
      response = await axios.put(url, payload);
    } else {
      response = await axios.post(url, payload);
    }

    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const uploadOrgDocuments = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS.REGISTRATION.uploadDocument, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const GetOrganizationDetail = async (type, id) => {
  try {
    const response = await axios.get(APIENDPOINTS.REGISTRATION.registration + `/${type}` + `/${id}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const FetchEnquiryData = async (
  page = 1,
  limit = 10,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = { doSort: false }
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS.DASHBOARD.displayEnquiry +
        `?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS.DASHBOARD.displayEnquiry +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}`;
    } else if (search.doSearch) {
      url = APIENDPOINTS.DASHBOARD.displayEnquiry + `?page=${page}&limit=${limit}&search=${search.value}`;
    } else {
      url = APIENDPOINTS.DASHBOARD.displayEnquiry + `?page=${page}&limit=${limit}`;
    }

    const response = await axios.get(url);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
    // console.log(error, 'displayBranchError', APIENDPOINTS?.DASHBOARD?.displayEnquiry);
  }
};

export const FetchApprovalData = async (
  page = 1,
  limit = 10,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = { doSort: false }
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS.DASHBOARD.approvalRequests +
        `?page=${page}&limit=${limit}&sortingColumnName=${sort.field}&sortingType=${sort.type}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS.DASHBOARD.approvalRequests +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}`;
    } else if (search.doSearch) {
      url = APIENDPOINTS.DASHBOARD.approvalRequests + `?page=${page}&limit=${limit}&search=${search.value}`;
    } else {
      url = APIENDPOINTS.DASHBOARD.approvalRequests + `?page=${page}&limit=${limit}`;
    }

    const response = await axios.get(url);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
    // console.log(error, 'displayBranchError', APIENDPOINTS?.DASHBOARD?.approvalRequests);
  }
};

export const UpdateApprovalData = async (id, data) => {
  try {
    const response = await axios.put(APIENDPOINTS?.DASHBOARD?.approvalRequests + `/${id}`, data);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const FetchOrganizationData = async (
  type,
  page = 1,
  limit = 10,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = { doSort: false }
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS.DASHBOARD.organization +
        `/${type}` +
        `?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS.DASHBOARD.organization +
        `/${type}` +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}`;
    } else if (search.doSearch) {
      url = APIENDPOINTS.DASHBOARD.organization + `/${type}` + `?page=${page}&limit=${limit}&search=${search.value}`;
    } else {
      url = APIENDPOINTS.DASHBOARD.organization + `/${type}` + `?page=${page}&limit=${limit}`;
    }
    let baseURL = axios.defaults.baseURL;
    // axios.defaults.baseURL = 'http://localhost:5001/api'
    const response = await axios.get(url);
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
    // console.log(error, 'FetchOrganizationData', APIENDPOINTS?.DASHBOARD?.displayEnquiry);
  }
};

export const FetchOrganizationDataById = async (type, orgId = '') => {
  try {
    const response = await axios.get(APIENDPOINTS?.DASHBOARD?.organization + `/${type}` + `/${orgId}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
    // console.log(error, 'FetchOrganizationDataById', APIENDPOINTS?.DASHBOARD?.displayEnquiry);
  }
};

export const ApproveOrgUser = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS.DASHBOARD.organization + `/${id}`, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const GetState = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.NEW_ESIGN?.getState);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};
export const GetDenomination = async (state, denominationAmount, documentId) => {
  try {
    const response = await axios.get(
      APIENDPOINTS?.NEW_ESIGN?.getDenomination +
        `/${documentId}?state=${state}&denominationAmount=${denominationAmount}`
    );
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};
export const FetchOrganizationTypeData = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.REGISTRATION?.organisationType);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
    // console.log(error, 'organisationTypeError');
  }
};
export const FetchFileIdById = async (orgId = '', id) => {
  try {
    const response = await axios.get(APIENDPOINTS?.REGISTRATION?.fileId + `/${orgId}` + `/${id}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
    // console.log(error, 'FetchFileIdById');
  }
};

export const FetchSavedEsign = async documentId => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL= 'http://localhost:5002/api/';
    const response = await axios.get(APIENDPOINTS?.SAVED_ESIGN.esign + `/${documentId}`);
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const EsignUpdate = async (documentId, payload) => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL= 'http://localhost:5002/api/';
    const response = await axios.put(APIENDPOINTS?.SAVED_ESIGN.update + `/${documentId}`, payload);
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const Esignfiledata = async (documentId, step) => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL= 'http://localhost:5002/api/';
    const response = await axios.get(APIENDPOINTS?.SAVED_ESIGN.filedata + `/${documentId}/${step}`);
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const getDeafultCordinate = async documentId => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL= 'http://localhost:5002/api/';
    const response = await axios.get(APIENDPOINTS?.SAVED_ESIGN.getDeafultCordinate + `/${documentId}`);
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const Esignsinglefiledata = async (documentId, filePath) => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL= 'http://localhost:5002/api/';
    const response = await axios.post(APIENDPOINTS?.SAVED_ESIGN.singlefiledata + `/${documentId}`, { filePath });
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const getFinalTemplatePdf = async (documentId, payload) => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL= 'http://localhost:5002/api/';
    const response = await axios.post(APIENDPOINTS?.NEW_ESIGN.getFinalPDF + `/${documentId}`, payload);
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const deleteSavedEsign = async documentId => {
  try {
    const response = await axios.delete(APIENDPOINTS?.SAVED_ESIGN.esign + `/${documentId}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
    // console.log(error, 'organisationTypeError');
  }
};

export const BrandTypeData = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.LOGIN?.brandType);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
    // console.log(error, 'brandTypeError');
  }
};

export const EnquiryStatus = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS.DASHBOARD.displayEnquiry + `/${id}`, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const step1 = async payload => {
  delete payload.templateName;
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL= 'http://localhost:5002/api/';
    const response = await axios.post(APIENDPOINTS?.NEW_ESIGN?.step1, payload);
    axios.defaults.baseURL = baseURL;
    if (response) return response;
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const NewESignsent = async documentID => {
  let baseURL = axios.defaults.baseURL;
  try {
    //axios.defaults.baseURL= 'http://localhost:5002/api/';
    const response = await axios.put(APIENDPOINTS?.NEW_ESIGN?.NewESignsent + `/${documentID}`);
    axios.defaults.baseURL = baseURL;
    if (response) return response;
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const saveStampDetails = async (documentId, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS.NEW_ESIGN?.saveStampDetails + `/${documentId}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const getSignCords = async (documentId, payload, remove = null) => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL= 'http://localhost:5002/api/';
    if (!documentId) {
      return payload;
    }
    let pdfdataUrl = null;
    if (payload.pdfdataUrl) {
      pdfdataUrl = payload.pdfdataUrl;
      delete payload.pdfdataUrl;
    }
    if (remove) {
      payload.remove = remove;
    }
    let response = await axios.put(APIENDPOINTS.NEW_ESIGN?.avalibleCoordinates, payload);
    axios.defaults.baseURL = baseURL;
    if (response) {
      if (pdfdataUrl) {
        response.pdfdataUrl = pdfdataUrl;
      }
      return response;
    }
    return payload;
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return { message: error.message };
  }
};

export const getStampPaper = async (documentId, payload) => {
  try {
    const response = await axios.get(APIENDPOINTS.NEW_ESIGN?.saveStampDetails + `/${documentId}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const blockStampPaperApi = async documentId => {
  try {
    const response = await axios.put(APIENDPOINTS.NEW_ESIGN?.getDenomination + `/${documentId}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetEsignDocument = async status => {
  try {
    const response = await axios.get(APIENDPOINTS?.DASHBOARD?.getEsignDocument + `?status=${status}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetSettings = async type => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.setting + `/${type}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const PutSettings = async (payload, type) => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.setting + `/${type}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetGlobalSettings = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.globalSettings);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const PutGlobalSettings = async payload => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.globalSettings, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetConfigData = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.NEW_ESIGN?.getConfig);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetDropDownData = async dataName => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.fetchDropDowndata + `/${dataName}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const FetchMenuDetails = async () => {
  try {
    const response = await axios.get(APIENDPOINTS.LOGIN.menu);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const GetProfilePic = async () => {
  try {
    const response = await axios.get(APIENDPOINTS.PROFILE.uploadPic);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const UpdateProfilePic = async payload => {
  try {
    const response = await axios.put(APIENDPOINTS.PROFILE.uploadPic, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const AddToWallet = async (orgId, data) => {
  try {
    const response = await axios.put(APIENDPOINTS.WALLET_PROTEAN.getProteanWallet + `/${orgId}`, data);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const PostExcelFile = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS.DASHBOARD.bulk, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const PostExcelFileUser = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS.DASHBOARD.bulkUser, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const PostPdfFileVendor = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS.DASHBOARD.vendorUploadDoc + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const PostPdfFileVendorSubmit = async id => {
  try {
    const response = await axios.put(APIENDPOINTS.DASHBOARD.vendorUploadDoc + `/${id}/submit`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const ApproveStampVendor = async id => {
  try {
    const response = await axios.put(APIENDPOINTS.DASHBOARD.approvalRequestStampApprove + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetAllVendorDoc = async id => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.getVendorDoc + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DeleteVendorDoc = async (stampOrderId, stampInventoryId) => {
  try {
    const response = await axios.delete(
      APIENDPOINTS.DASHBOARD.vendorUploadDoc + `/${stampOrderId}/${stampInventoryId}`
    );
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const PutCourierDetails = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS.DASHBOARD.courierVendor + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

// ----------------------------- Filter Dashboard and Wallet API ----------------------------------- //
const generateApiUrl = (baseApiUrl, payload) => {
  let url = `${baseApiUrl}?page=${payload.page}&limit=${payload.limit}`;

  if (payload.sortingColumnName && payload.sortingType) {
    url += `&sortingColumnName=${payload.sortingColumnName}&sortingType=${payload.sortingType}`;
  }

  if (payload.quickDateFrom && payload.quickDateTo) {
    url += `&quickDateFrom=${payload.quickDateFrom}&quickDateTo=${payload.quickDateTo}`;
  }

  if (payload.search) {
    url += `&search=${payload.search}`;
  }

  if (payload.filterValue) {
    url += `&filterValue=${payload.filterValue}`;
  }

  if (payload.filterColumnName) {
    url += `&filterColumnName=${payload.filterColumnName}`;
  }

  return url;
};

const makeApiRequest = async (endpoint, payload) => {
  try {
    const apiUrl = generateApiUrl(endpoint, payload);
    // let baseUrl = axios.defaults.baseURL;
    // if(endpoint === '/report/v1/history/email'){
    //   axios.defaults.baseURL = 'http://localhost:5004/api';
    // }else if (endpoint === '/esign/v1/wallet/request-transaction') {
    //   axios.defaults.baseURL = 'http://localhost:5000/api';
    // }
    const response = await axios.get(apiUrl);
    // axios.defaults.baseURL = baseUrl;
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

const getRequest = async (endpoint, payload, query = '') => {
  try {
    const response = await axios.get(endpoint + `/${payload}${query ? '?' + query : ''}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

const postRequest = async (endpoint, payload) => {
  try {
    const response = await axios.post(endpoint + `/${payload}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

const putRequest = async (endpoint, id, payload) => {
  try {
    let response;
    if (payload) response = await axios.put(`${endpoint}/${id}`, payload);
    else response = await axios.put(`${endpoint}/${id}`);

    return response;
  } catch (error) {
    return error?.response;
  }
};

const deleteRequest = async (endpoint, id, payload) => {
  try {
    let response;
    if (payload) response = await axios.delete(`${endpoint}/${id}`, payload);
    else response = await axios.delete(`${endpoint}/${id}`);

    return response;
  } catch (error) {
    return error?.response;
  }
};
// ------------------------------------------------------------------------------------------------- //
// ---------------------------------- Dashboard API ------------------------------------------------ //
export const esignDraft = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.esignDraft, payload);
export const esignAwaitingSigning = async payload =>
  makeApiRequest(APIENDPOINTS.DASHBOARD.esignAwaitingSigning, payload);
export const esignSigned = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.esignSigned, payload);
export const esignCustomerRejected = async payload =>
  makeApiRequest(APIENDPOINTS.DASHBOARD.esignCustomerRejected, payload);
export const approvalSent = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.approvalSent, payload);
export const approvalApproved = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.approvalApproved, payload);
export const approvalRejected = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.approvalRejected, payload);
export const digitalStampOrderRequest = async payload =>
  makeApiRequest(APIENDPOINTS.DASHBOARD.digitalStampOrderRequest, payload);
export const digitalStampAwaitingAproval = async payload =>
  makeApiRequest(APIENDPOINTS.DASHBOARD.digitalStampAwaitingApproval, payload);
export const digitalStampOrderConfirmed = async payload =>
  makeApiRequest(APIENDPOINTS.DASHBOARD.digitalStampOrderConfirmed, payload);
export const digitalStampOrderRejected = async payload =>
  makeApiRequest(APIENDPOINTS.DASHBOARD.digitalStampOrderRejected, payload);
export const digitalStampOrderInventory = async payload =>
  makeApiRequest(APIENDPOINTS.DASHBOARD.digitalStampOrderInventory, payload);
export const proteanStampRequest = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.proteanStampRequest, payload);
export const proteanForwardToVendor = async payload =>
  makeApiRequest(APIENDPOINTS.DASHBOARD.proteanForwardToVendor, payload);
export const proteanOrder = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.proteanOrder, payload);
export const proteanForwardToCustomers = async payload =>
  makeApiRequest(APIENDPOINTS.DASHBOARD.proteanForwardToCustomers, payload);
export const vendorStampRequest = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.vendorStampRequest, payload);
export const vendorAcceptedOrder = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.vendorAcceptedOrder, payload);
export const vendorRejectedOrder = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.vendorRejectedOrder, payload);
export const vendorSentOrder = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.vendorSentOrder, payload);

export const DigitalStampOrderDetails = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS.DASHBOARD.digitalStampOrder, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DigitalStampDemominationOrderRequest = async (payload, signal) => {
  try {
    const response = await axios.put(APIENDPOINTS?.DASHBOARD?.digitalStampOrder, payload, {
      signal
    });
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DigitalStampOrderGetState = async () => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.digitalStampOrderGetState);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const DigitalStampOrderViewDetails = async stampId => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.digitalStampViewDetails + `/${stampId}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const DigitalStampProteanOrderViewDetails = async stampId => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.digitalStampProteanViewDetails + `/${stampId}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const cancelProteanOrderApi = async id => {
  try {
    const response = await axios.put(APIENDPOINTS?.DASHBOARD?.cancelProteanOrder + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const VendorOrderViewDetails = async stampId => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.vendorOrderViewDetails + `/${stampId}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const StampRejectApi = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS.DASHBOARD.approvalRequestStampReject + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DeleteDocumentId = async documentId => {
  return deleteRequest(APIENDPOINTS.DASHBOARD.deleteDocumentId, documentId);
};

export const GetAuditTrail = async id => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.auditTrail + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const NotifyRecipientEmail = async DocumentId => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.NotifyRecipientEmail + `/${DocumentId}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const NotifyRecipientPayment = async DocumentId => {
  try {
    const response = await axios.put(APIENDPOINTS.DASHBOARD.NotifyRecipientPayment + `/${DocumentId}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const NotifyRecipientChecker = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS.DASHBOARD.NotifyRecipientChecker, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};
export const NotifyRecipientSendEmail = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS.DASHBOARD.NotifyRecipientSendEmail, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetPendingPaymentList = async payload =>
  makeApiRequest(APIENDPOINTS.DASHBOARD.getPendingPaymentList, payload);

export const GetAllDashboardDocumentCount = async (payload, params) => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.getDashboardCount + `/${payload}`, {
      params
    });

    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const resendMail = async payload => {
  try {
    const response = await axios.get(APIENDPOINTS?.DASHBOARD?.resentMail + `/${payload}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

// ------------------------------------------------------------------------------------------------- //
// ------------------------------------ Wallet API ------------------------------------------------- //
export const GetProteanWalletDetails = async payload =>
  makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.getProteanWallet, payload);
export const walletRequestTransaction = async payload =>
  makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.requestTransaction, payload);
export const walletAccountLeadger = async payload => makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.accountLedger, payload);
export const walletTransaction = async payload => makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.transaction, payload);

export const walletESignConsumption = async payload =>
  makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.eSignConsumption, payload);
export const walletApprovalSent = async payload => makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.approvalSent, payload);
export const walletApprovalApproved = async payload =>
  makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.approvalApproved, payload);
export const walletApprovalRejected = async payload =>
  makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.approvalRejected, payload);
export const walletApproval = async payload => makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.approval, payload);
export const PutProteanWallet = async payload => {
  try {
    let baseURL = axios.defaults.baseURL;
    // axios.defaults.baseURL = 'http://localhost:5000/api/';
    const response = await axios.put(APIENDPOINTS.WALLET_PROTEAN.putProteanWallet, payload);
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const PutProteanWalletDetailsProtean = async (orgId, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS.WALLET_PROTEAN.putProteanWallet + `/${orgId}`, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const PutProteanWalletApproveApproval = async walletTxnId => {
  try {
    const response = await axios.put(APIENDPOINTS.WALLET_PROTEAN.approveApproval + `/${walletTxnId}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const PutProteanWalletRejectApproval = async (walletTxnId, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS.WALLET_PROTEAN.rejectApproval + `/${walletTxnId}`, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const walletBalance = async () => {
  try {
    const response = await axios.get(APIENDPOINTS.WALLET_PROTEAN.balance);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const walletRazorpayPayment = async amount => {
  try {
    let baseURL = axios.defaults.baseURL;
    // axios.defaults.baseURL = 'http://localhost:5000/api/';
    const response = await axios.post(APIENDPOINTS.WALLET_PROTEAN.razorpayPayment, { amount });
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const razorpayWalletTopupStatus = async walletTxnId => {
  try {
    const response = await axios.get(APIENDPOINTS.WALLET_PROTEAN.walletTopupstatus + `/${walletTxnId}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const vpaDetails = async () => {
  try {
    let baseURL = axios.defaults.baseURL;
    // axios.defaults.baseURL = 'http://localhost:5000/api/';
    const response = await axios.get(APIENDPOINTS.WALLET_PROTEAN.vpaDetails);
    axios.defaults.baseURL = baseURL;
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const vpaDetailsForProtean = async orgId => {
  try {
    const response = await axios.get(APIENDPOINTS.WALLET_PROTEAN.vpaDetailsProtean + `/${orgId}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const GetFinOps = async payload => makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.finOps, payload);

export const PutStampApproveFinOps = async payload =>
  makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.stampApproveFinOps, payload);

export const PutStampRejectFinOps = async payload =>
  makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.stampRejectFinOps, payload);

export const GetHistoryWorkflow = async payload => makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.historyWorkflow, payload);
export const GetSmsHistory = async payload => makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.smsHistory, payload);
export const GetEmailHistory = async payload => makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.emailHistory, payload);

export const PostStampApproveFinOps = async documentId => {
  return putRequest(APIENDPOINTS.WALLET_PROTEAN.stampApproveFinOps, documentId);
};

export const PostStampRejectFinOps = async (documentId, payload) => {
  return putRequest(APIENDPOINTS.WALLET_PROTEAN.stampRejectFinOps, documentId, payload);
};

export const GetAllDocCountHistory = async selectedQuickDate => {
  try {
    const response = await axios.get(
      APIENDPOINTS.WALLET_PROTEAN.getWalletHistoryTabCount +
        `?quickDateFrom=${selectedQuickDate.quickDateFrom}&quickDateTo=${selectedQuickDate.quickDateTo}`
    );
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetWalletDocCount = async (payload, { quickDateFrom, quickDateTo }) => {
  try {
    const response = await axios.get(
      APIENDPOINTS.WALLET_PROTEAN.getWalletDocCount +
        `/${payload}` +
        `?quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`
    );
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};
// ------------------------------------------------------------------------------------------------- //
// ---------------------------------- Approval Request --------------------------------------------- //
export const GetApprovalRequest = async payload => makeApiRequest(APIENDPOINTS.DASHBOARD.approvalRequest, payload);
export const GetApprovalRequestStamp = async payload => {
  return getRequest(APIENDPOINTS.DASHBOARD.approvalRequestStamp, payload);
};

export const GetApprovalRequestEsign = async (payload, query = '') => {
  return getRequest(`${APIENDPOINTS.DASHBOARD.approvalRequestEsign}`, payload, query);
};

export const PostApprovalRequestStampApprove = async documentId => {
  return putRequest(APIENDPOINTS.DASHBOARD.approvalRequestStampApprove, documentId);
};

export const PostApprovalRequestStampReject = async (documentId, payload) => {
  return putRequest(APIENDPOINTS.DASHBOARD.approvalRequestStampReject, documentId, payload);
};

export const PutApprovalRequestEsignApprove = async documentId => {
  return putRequest(APIENDPOINTS.DASHBOARD.approvalRequestEsignApprove, documentId);
};
export const PutApprovalRequestPaymentApprove = async documentId => {
  return putRequest(APIENDPOINTS.DASHBOARD.NotifyPayeeRecipientSendEmail, documentId);
};

export const PutpprovalRequestEsignReject = async (documentId, payload) => {
  return putRequest(APIENDPOINTS.DASHBOARD.approvalRequestEsignReject, documentId, payload);
};
export const PutApprovalRequestEsignAction = async (documentId, payload) => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL = 'http://localhost:5002/api/';
    // axios.defaults.mode = 'no-cors';
    let response = await axios.put(APIENDPOINTS.DASHBOARD.approvalRequestEsignAction + `${documentId}`, payload);
    axios.defaults.baseURL = baseURL;
    return response;
  } catch (error) {
    axios.defaults.baseURL = baseURL;
  }
};

// ------------------------------------------------------------------------------------------------- //

export const SendExcelFile = async id => {
  try {
    const response = await axios.put(APIENDPOINTS.DASHBOARD.bulk + `/${id}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const DashboardAcceptedWithVendorId = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS.DASHBOARD.approvalRequestStampApprove + `/${id}`, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const SendExcelFileUser = async id => {
  try {
    const response = await axios.put(APIENDPOINTS.DASHBOARD.bulkUser + `/${id}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const VendorList = async stampId => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.vendorList + `/${stampId}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const forwardToEntityAccept = async id => {
  try {
    const response = await axios.put(
      APIENDPOINTS.DASHBOARD.approvalRequestStampApprove + `/${id}` + `/forward-to-entity`
    );
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const forwardToEntityReject = async (id, payload) => {
  try {
    const response = await axios.put(
      APIENDPOINTS.DASHBOARD.approvalRequestStampReject + `/${id}` + `/forward-to-entity`,
      payload
    );
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const RefreshToken = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS.LOGIN.refreshToken, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DeleteRefreshToken = async token => {
  try {
    const response = await axios.delete(APIENDPOINTS.LOGIN.refreshToken, {
      data: {
        refreshToken: token
      }
    });
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

const generateStatsApiUrl = (endPoint, payload) => {
  let url = `${endPoint}?workflowType=${payload.workFlowType}&fromDate=${payload.startDate}&toDate=${payload.endDate}`;

  if (payload.state) {
    url += `&state=${payload.state}`;
  }
  if (payload.city) {
    url += `&city=${payload.city}`;
  }
  if (payload.groupingId || payload.groupingId === 0) {
    url += `&groupingId=${payload.groupingId}`;
  }
  return url;
};

export const StatisticsOverView = async payload => {
  try {
    const apiUrl = generateStatsApiUrl(APIENDPOINTS.STATISTIC_OVERVIEW.piechartWorkFlow, payload);
    const response = await axios.get(apiUrl);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
const generateSBCUrl = (endPoint, payload) => {
  let url = `${endPoint}/${payload.type}?workflowType=${payload.workflowType}`;

  if (payload.type === 'cities') {
    url += `&state=${payload.state}`;
  }
  if (payload.type === 'branches') {
    url += `&state=${payload.state}&city=${payload.city}`;
  }

  return url;
};
export const StatisticsSCBDropdown = async payload => {
  try {
    const apiUrl = generateSBCUrl(APIENDPOINTS.STATISTIC_OVERVIEW.states, payload);
    const response = await axios.get(apiUrl);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const StatisticsBarChart = async type => {
  try {
    const response = await axios.get(`${APIENDPOINTS.STATISTIC_OVERVIEW.barchart}?workflowType=${type}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const StatisticsWorkflowPopup = async payload => {
  try {
    const apiUrl = generateStatsApiUrl(APIENDPOINTS.STATISTIC_OVERVIEW.viewPopupWorkFlow, payload);
    const response = await axios.get(apiUrl);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
export const StatisticsWorkflowOrderPopup = async payload => {
  try {
    const apiUrl = generateStatsApiUrl(APIENDPOINTS.STATISTIC_OVERVIEW.viewPopUpOrders, payload);
    const response = await axios.get(apiUrl);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const FetchLocationFromPincode = async pincode => {
  try {
    const response = await axios.get(APIENDPOINTS.DASHBOARD.fetchLocationByPincode + `/${pincode}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
/*-------------------------------------Download Excel and CVS file from wallet ------------------------------------*/
export const downloadData = async (endpoint, downloadType, quickDateFrom, quickDateTo) => {
  try {
    const response = await axios.get(
      `${endpoint}?type=${downloadType}&quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const DownloadStampProcurement = async (downloadType, quickDateFrom, quickDateTo) => {
  return downloadData(APIENDPOINTS.WALLET_PROTEAN.downloadStampProcurement, downloadType, quickDateFrom, quickDateTo);
};

export const ESignConsumptionDownload = async (downloadType, quickDateFrom, quickDateTo) => {
  return downloadData(APIENDPOINTS.WALLET_PROTEAN.ESignConsumptionDownload, downloadType, quickDateFrom, quickDateTo);
};

export const DownloadAccountLedgerData = async (type, quickDateFrom, quickDateTo) => {
  try {
    const response = await axios.get(
      APIENDPOINTS.WALLET_PROTEAN.accountLedgerDownload +
        `?type=${type}&quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`
    );
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DownloadRequestTransaction = async (type, quickDateFrom, quickDateTo) => {
  try {
    const response = await axios.get(
      APIENDPOINTS.WALLET_PROTEAN.requestTransactionDownload +
        `?type=${type}&quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`
    );
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const WorkflowDownload = async (type, quickDateFrom, quickDateTo, filters = {}) => {
  try {
    const response = await axios.get(APIENDPOINTS.WALLET_PROTEAN.workflowDownload, {
      params: {
        type,
        quickDateFrom,
        quickDateTo,
        ...filters
      }
    });
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DownloadSMSHistory = async (type, quickDateFrom, quickDateTo) => {
  try {
    const response = await axios.get(
      APIENDPOINTS.WALLET_PROTEAN.smsHistory +
        '/download' +
        `?type=${type}&quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`
    );
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DownloadEmailHistory = async (type, quickDateFrom, quickDateTo) => {
  try {
    const response = await axios.get(
      APIENDPOINTS.WALLET_PROTEAN.emailHistory +
        '/download' +
        `?type=${type}&quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`
    );
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
/*-----------------------------------------------------------------------------------------------------------------*/

export const SmsConfigurationAdd = async payload => {
  try {
    const response = await axios.put(APIENDPOINTS.SETTING.smsConfiguration, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const SmsConfigurationGet = async type => {
  try {
    const response = await axios.get(APIENDPOINTS.SETTING.smsConfiguration + `?isFillable=${type}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const EmailConfigurationAdd = async payload => {
  try {
    const response = await axios.put(APIENDPOINTS.SETTING.emailConfiguration, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const EmailConfigurationGet = async type => {
  try {
    const response = await axios.get(APIENDPOINTS.SETTING.emailConfiguration + `?isFillable=${type}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};
/*------------------------------------------------- State Master --------------------------------------------------*/

export const GetStateMaster = async (
  page = 1,
  limit = 100,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = {}
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS?.SETTING?.stateMaster +
        `list?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS?.SETTING?.stateMaster +
        `list?filterValue=${filter.value}&filterColumnName=${filter.field}&page=${page}&limit=${limit}`;
    } else if (search.doSearch) {
      url = APIENDPOINTS?.SETTING?.stateMaster + `list?page=${page}&limit=${limit}&search=${search.value}`;
    } else {
      url = APIENDPOINTS?.SETTING?.stateMaster + `list?page=${page}&limit=${limit}`;
    }
    // let baseURL = axios.defaults.baseURL;
    // axios.defaults.baseURL = 'http://localhost:5000/api/';
    const response = await axios.get(url);
    // axios.defaults.baseURL = baseURL;
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateState = async (id, payload) => {
  if (Object.keys(payload).length === 1) {
    try {
      const response = await axios.put(APIENDPOINTS?.SETTING?.stateMaster + `state/${id}`, payload);
      if (response) return response;
    } catch (error) {
      return error?.response;
    }
  }
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.stateMaster + `edit-state-list/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetSingleStateDetails = async id => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.stateMaster + `state/details/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DownloadSampleTemplate = async type => {
  try {
    const response = await axios.get(APIENDPOINTS?.DASHBOARD?.downloadSampleTemplate + `?type=${type}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DownloadSampleTemplateBulkUpload = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.DASHBOARD?.downloadSampleTemplateBulkUpload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DownloadTemplate = async (id, type) => {
  try {
    const response = await axios.get(APIENDPOINTS?.DASHBOARD?.downloadTemplate + `/${id}` + `?type=${type}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UploadBulkTemplate = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.DASHBOARD?.uploadBulkTemplate, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetBulkTemplateStatus = async payload => {
  await new Promise(resolve => setTimeout(resolve, 200));
  return await makeApiRequest(APIENDPOINTS.DASHBOARD.getBulkTemplateStatus, payload);
};

// export const GetBulkTemplateStatus = async () => {
//   try {
//     const response = await axios.get(APIENDPOINTS?.DASHBOARD?.getBulkTemplateStatus);
//     if (response) return response;
//   } catch (error) {
//     return error?.response;
//   }
// };

export const DownloadBulkTemplate = async (id, type) => {
  try {
    const response = await axios.get(
      APIENDPOINTS?.DASHBOARD?.downloadBulkTemplateStatusDetails + `/${id}` + `?type=${type}`
    );
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

/*-----------------------------------------------------------------------------------------------------------------*/

/*------------------------------------------------ Plan Management ------------------------------------------------*/
export const AddNewPlan = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.SETTING?.planManagement, payload);
    // console.log('response ', response);
    if (response) return response;
  } catch (error) {
    return error.response;
  }
};

export const GetAllPlanList = async (page, limit, filter = { doFilter: false }, sort = { doSort: false }) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS?.SETTING?.planManagement +
        `?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS?.SETTING?.planManagement +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}`;
    } else {
      url = APIENDPOINTS?.SETTING?.planManagement + `?page=${page}&limit=${limit}`;
    }
    const response = await axios.get(url);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetSinglePlan = async id => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.planManagement + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetAvailablePlan = async (type, id) => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.planManagement + `/available/${type}` + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetAvailablePlanforOrganization = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.planManagement);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdatePlan = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.planManagement + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DeletePlan = async id => {
  try {
    const response = await axios.delete(APIENDPOINTS?.SETTING?.planManagement + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

/*-----------------------------------------------------------------------------------------------------------------*/

export const IndividualUserSignUp = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.REGISTRATION?.individualUser + `/signup`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const FetchIndividualUserData = async (
  page = 1,
  limit = 10,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = { doSort: false }
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS?.REGISTRATION?.individualUser +
        `?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS?.REGISTRATION?.individualUser +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}`;
    } else if (search.doSearch) {
      url = APIENDPOINTS?.REGISTRATION?.individualUser + `?page=${page}&limit=${limit}&search=${search.value}`;
    } else {
      url = APIENDPOINTS?.REGISTRATION?.individualUser + `?page=${page}&limit=${limit}`;
    }
    const response = await axios.get(url);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const GetSingleIndividualUser = async id => {
  try {
    const response = await axios.get(APIENDPOINTS?.REGISTRATION?.individualUser + `/single/${id}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const ChnageIndividualUserStatus = async id => {
  try {
    const response = await axios.put(APIENDPOINTS?.REGISTRATION?.individualUser + `/status/${id}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const UpdateIndividualUserData = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS?.REGISTRATION?.individualUser + `/${id}`, payload);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const DeleteIndividualUser = async id => {
  try {
    const response = await axios.delete(APIENDPOINTS?.REGISTRATION?.individualUser + `/delete/${id}`);
    if (response) {
      return response;
    }
  } catch (error) {
    return error?.response;
  }
};

export const TermsAndConditionsConfig = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.SETTING?.termsAndConditions, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetTermsAndConditionsConfig = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.termsAndConditions);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateDefaultBranch = async id => {
  try {
    const response = await axios.put('/iam/v1/branch/set-default/' + id);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

/*----------------------------------------------------SMS And Email Templates-------------------------------------------------------------*/

export const GetAllSmsTemplates = async (
  page = 1,
  limit = 100,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = { doSort: false }
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS?.SETTING?.smsTemplate +
        '/list' +
        `?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS?.SETTING?.smsTemplate +
        '/list' +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}`;
    } else if (search.doSearch) {
      url = APIENDPOINTS.SETTING.smsTemplate + '/list' + `?page=${page}&limit=${limit}&search=${search.value}`;
    } else {
      url = APIENDPOINTS?.SETTING?.smsTemplate + '/list' + `?page=${page}&limit=${limit}`;
    }

    const response = await axios.get(url);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetSingleSmsTemplate = async id => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.smsTemplate + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const AddSmsTemplate = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.SETTING?.smsTemplate, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateSmsTemplate = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.smsTemplate + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DeleteSmsTemplate = async id => {
  try {
    const response = await axios.delete(APIENDPOINTS?.SETTING?.smsTemplate + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetSMSTemplateNameList = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.smsTemplate + '/name/list');
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetSMSVariableList = async payload => {
  try {
    const response = await axios.get(
      APIENDPOINTS?.SETTING?.smsTemplate + `/variable/list?templateName=${payload}&category=sms`
    );
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetAllEmailTemplates = async (
  page = 1,
  limit = 100,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = { doSort: true, field: 'templateName', type: 'asc' }
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS?.SETTING?.emailTemplate +
        '/list' +
        `?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS?.SETTING?.emailTemplate +
        '/list' +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}`;
    } else if (search.doSearch) {
      url = APIENDPOINTS.SETTING.emailTemplate + '/list' + `?page=${page}&limit=${limit}&search=${search.value}`;
    } else {
      url = APIENDPOINTS?.SETTING?.emailTemplate + '/list' + `?page=${page}&limit=${limit}`;
    }

    const response = await axios.get(url);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetSingleEmailTemplate = async id => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.emailTemplate + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const AddEmailTemplate = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.SETTING?.emailTemplate, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateEmailTemplate = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.emailTemplate + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DeleteEmailTemplate = async id => {
  try {
    const response = await axios.delete(APIENDPOINTS?.SETTING?.emailTemplate + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetEmailTemplateNameList = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.emailTemplate + '/name/list');
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetEmailVariableList = async payload => {
  try {
    const response = await axios.get(
      APIENDPOINTS?.SETTING?.emailTemplate + `/variable/list?templateName=${payload}&category=email`
    );
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};
/*----------------------------------------------------DMS Provider-------------------------------------------------------------*/

export const GetAllDmsProviderList = async (
  isFillable,
  page = 1,
  limit = 100,
  filter = { doFilter: false },
  search = { doSearch: false },
  sort = { doSort: false }
) => {
  try {
    let url = '';
    if (sort.doSort) {
      url =
        APIENDPOINTS?.SETTING?.dmsProvider +
        `?sortingColumnName=${sort.field}&sortingType=${sort.type}&page=${page}&limit=${limit}&isFillable=${isFillable}`;
    } else if (filter.doFilter) {
      url =
        APIENDPOINTS?.SETTING?.dmsProvider +
        `?filterValue=${filter.value}&filterColumnName=${filter.column}&page=${page}&limit=${limit}&isFillable=${isFillable}`;
    } else if (search.doSearch) {
      url =
        APIENDPOINTS.SETTING.dmsProvider +
        `?page=${page}&limit=${limit}&search=${search.value}&isFillable=${isFillable}`;
    } else {
      url = APIENDPOINTS?.SETTING?.dmsProvider + `?page=${page}&limit=${limit}&isFillable=${isFillable}`;
    }

    const response = await axios.get(url);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetDmsProviderNames = async () => {
  let baseURL = axios.defaults.baseURL;
  try {
    // axios.defaults.baseURL = 'http://localhost:5002/api/';
    // axios.defaults.mode = 'no-cors';
    const response = await axios.get(APIENDPOINTS?.SETTING?.dmsProvider + '/names');
    axios.defaults.baseURL = baseURL;
    if (response) return response;
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

export const GetSingleDmsProvider = async id => {
  try {
    const response = await axios.get(APIENDPOINTS?.SETTING?.dmsProvider + `/get/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const AddDmsProvider = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.SETTING?.dmsProvider, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateDmsProvider = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.dmsProvider + `/update/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DeleteDmsProvider = async id => {
  try {
    const response = await axios.delete(APIENDPOINTS?.SETTING?.dmsProvider + `/delete/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateDmsProviderConfig = async payload => {
  try {
    const response = await axios.put(APIENDPOINTS?.SETTING?.dmsProvider + '/update-config', payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const TestDmsConnection = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.SETTING?.dmsTestConnection, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const TestSMSConnection = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.SETTING?.smsTestConnection, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const TestEmailConnection = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.SETTING?.emailTestConnection, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const TestPaymentGatewayConnection = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.SETTING?.paymentTestConnection, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GoogleAuthURL = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.LOGIN?.googleAuth);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const AzureAuthURL = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.LOGIN?.azureAuth);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetAccessTokenUsingGoogleCode = async payload => {
  try {
    let baseURL = axios.defaults.baseURL;
    // axios.defaults.baseURL = 'http://localhost:5001/api/';
    const response = await axios.post(APIENDPOINTS?.LOGIN?.accessTokenUsingGoogle, payload);
    axios.defaults.baseURL = baseURL;
    if (response) return response;
  } catch (error) {
    if (error.message) {
      toast.error(error.message, {
        position: 'bottom-center',
        toastId: 'api-config-error-1'
      });
    }
    return error?.response;
  }
};

export const GetAccessTokenUsingAzureCode = async payload => {
  try {
    let baseURL = axios.defaults.baseURL;
    // axios.defaults.baseURL = 'http://localhost:5001/api/';
    const response = await axios.post(APIENDPOINTS?.LOGIN?.accessTokenUsingAzure, payload);
    axios.defaults.baseURL = baseURL;
    if (response) return response;
  } catch (error) {
    if (error.message) {
      toast.error(error.message, {
        position: 'bottom-center',
        toastId: 'api-config-error-2'
      });
    }
    return error?.response;
  }
};

/*--------------------------------------------New eSign Steps-----------------------------------------------------*/

export const GetSteps = async (steps, id) => {
  let baseURL = axios.defaults.baseURL;
  try {
    if (!id) return;
    // axios.defaults.baseURL = 'http://localhost:5002/api/';
    const response = await axios.get(APIENDPOINTS?.NEW_ESIGN?.getSteps + `/${steps}/${id}`);
    axios.defaults.baseURL = baseURL;
    if (response) return response;
  } catch (error) {
    axios.defaults.baseURL = baseURL;
    return error?.response;
  }
};

/*--------------------------------------------Manage Org Billing Profiles And Invoices-----------------------------------------------------*/

export const GroupingBranchList = async () => {
  try {
    const response = await axios.get(APIENDPOINTS?.WALLET_PROTEAN?.groupingBranchList);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetBillingProfilesList = async (page = 1, limit = 100) => {
  try {
    let baseURL = axios.defaults.baseURL;
    // axios.defaults.baseURL = 'http://localhost:5000/api/';
    let url = APIENDPOINTS?.WALLET_PROTEAN?.manageBillingProfiles + `?page=${page}&limit=${limit}`;
    const response = await axios.get(url);
    axios.defaults.baseURL = baseURL;
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};
export const GetBillingProfileById = async id => {
  try {
    const response = await axios.get(APIENDPOINTS?.WALLET_PROTEAN?.manageBillingProfiles + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const AddBillingProfile = async payload => {
  try {
    const response = await axios.post(APIENDPOINTS?.WALLET_PROTEAN?.manageBillingProfiles, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const UpdateBillingProfile = async (id, payload) => {
  try {
    const response = await axios.put(APIENDPOINTS?.WALLET_PROTEAN?.manageBillingProfiles + `/${id}`, payload);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const DeleteBillingProfile = async id => {
  try {
    const response = await axios.delete(APIENDPOINTS?.WALLET_PROTEAN?.manageBillingProfiles + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

export const InvoicesList = async payload => makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.invoiceBill, payload);

export const GetInvoiceDetail = async id => {
  try {
    const response = await axios.get(APIENDPOINTS?.WALLET_PROTEAN?.invoiceBill + `/${id}`);
    if (response) return response;
  } catch (error) {
    return error?.response;
  }
};

// export const GetOrganizationsList = async payload =>
//   makeApiRequest(APIENDPOINTS.REGISTRATION.registration + '/Organization', payload);
export const GetOrganizationsList = async payload => {
  try {
    // let baseURL=   axios.defaults.baseURL;
    // axios.defaults.baseURL= 'http://localhost:5001/api/';
    const response = await axios.get(
      `${APIENDPOINTS.REGISTRATION.registration}/Organization?retrieveAll=${payload.retrieveAll}`
    );
    // axios.defaults.baseURL= baseURL;
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const uploadSignature = async payload => {
  try {
    const response = await axios.put(`${APIENDPOINTS.SIGNATURE.uploadSignature}`, payload);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const deleteSignature = async () => {
  try {
    const response = await axios.delete(`${APIENDPOINTS.SIGNATURE.uploadSignature}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const getSignature = async () => {
  try {
    const response = await axios.get(`${APIENDPOINTS.SIGNATURE.uploadSignature}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const getArticleCodes = async id => {
  try {
    const response = await axios.get(`${APIENDPOINTS.ARTICLECODE.articleCode}/${id}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const getDownloadUrl = async (type, id) => {
  try {
    const response = await axios.get(`${APIENDPOINTS.DASHBOARD.download}/${id}?type=${type}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const getWalletDownloadUrl = async (tabName, type, quickDateFrom, quickDateTo) => {
  try {
    let url = `${APIENDPOINTS.WALLET_PROTEAN.download}/${tabName}?type=${type}`;
    if (quickDateFrom) {
      url += `&quickDateFrom=${quickDateFrom}`;
    }
    if (quickDateTo) {
      url += `&quickDateTo=${quickDateTo}`;
    }
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const getInventoryData = async (stateId = '', payload) => {
  try {
    const response = await axios.get(APIENDPOINTS.INVENTORY.inventory + '/fetch', {
      params: {
        stateId,
        ...payload
      }
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const getStampDataById = async (stampInventoryId = '') => {
  try {
    const response = await axios.get(APIENDPOINTS.INVENTORY.inventory + '/' + stampInventoryId);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const updateInventory = async (type = '', stampInventoryId = '', data) => {
  try {
    const response = await axios.put(APIENDPOINTS.INVENTORY.inventory + '/' + type, {
      stampInventoryIds: [stampInventoryId],
      ...data
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const downloadInventoryData = async (payload = {}) => {
  try {
    const response = await axios.get(APIENDPOINTS.INVENTORY.inventory + '/download', {
      params: payload
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const updateBulkInventory = async (type = '', stampInventoryIds = [], data) => {
  try {
    const response = await axios.put(APIENDPOINTS.INVENTORY.inventory + '/' + type, {
      stampInventoryIds,
      ...data
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const getInventoryStateName = async stateId => {
  try {
    const response = await axios.get(APIENDPOINTS.INVENTORY.state + `/${stateId}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const getAvailableStatus = async (stateId = '', denomination = '') => {
  try {
    const response = await axios.get(APIENDPOINTS.INVENTORY.inventoryStatus + `/${stateId}` + `/${denomination}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};


export const getDocument = async (stampOrderId = '', pageNumber = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.digitalStampDocument
				+ `/${stampOrderId}/page/${pageNumber}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getVendorDocFile = async (stampInventoryId = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.getVendorDocFile + `/${stampInventoryId}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};
